import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { addPollToRoomFromTemplateRequested } from 'features/polls/actions';
import { selectPollTemplateById } from 'features/polls/pollsSlice';
import { type PollTemplate } from 'features/polls/types';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* addPollToRoomFromTemplateSaga(
  action: ReturnType<typeof addPollToRoomFromTemplateRequested>
) {
  const { id: templateId } = action.payload;

  const template: PollTemplate = yield select(selectPollTemplateById, templateId);

  if (!template) {
    return;
  }

  const choices =
    template.type === 'free' ? undefined : template.choices?.map((choice) => choice.text);

  yield call(SignalingSocket.send, {
    event: 'createPoll',
    data: {
      templateId,
      question: template.question,
      type: template.type,
      choices,
      anonymous: template.anonymous,
    },
  });

  yield call(notification, i18n.t('notifications:polls.template_added_to_room'));
}
